import React, { useState } from "react";
import { X, Download, Copy, Check, Share2 } from "lucide-react";
import { toast } from "sonner";
import ShareSheet from "./ShareSheet";
import { shareUrl, promoUrl } from "../api";

export const PROMO_FORMATS = [
  { fmt: "story", label: "Story", size: "1080×1920", aspect: "aspect-[9/16]" },
  { fmt: "feed", label: "Feed Post", size: "1080×1080", aspect: "aspect-square" },
  { fmt: "og", label: "Link Preview", size: "1200×630", aspect: "aspect-[1200/630]" },
];

const PromoTile = ({ ctype, id, fmt, label, size, aspect }) => (
  <div className="flex flex-col" data-testid={`promo-tile-${fmt}`}>
    <div className={`${aspect} border border-neutral-800 bg-black overflow-hidden`}>
      <img src={promoUrl(ctype, id, fmt)} alt={`${label} promo`} loading="lazy" className="w-full h-full object-cover" data-testid={`promo-img-${fmt}`} />
    </div>
    <div className="mt-2 flex items-center justify-between gap-2">
      <div>
        <div className="font-headline text-sm uppercase">{label}</div>
        <div className="font-mono-label text-[9px] text-neutral-500">{size}</div>
      </div>
      <a href={promoUrl(ctype, id, fmt, true)} download className="btn-ghost !py-2 !px-3 text-[10px]" data-testid={`promo-download-${fmt}`}>
        <Download size={12} /> Save
      </a>
    </div>
  </div>
);

export const PromoKitModal = ({ ctype, item, onClose }) => {
  const [copied, setCopied] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const link = shareUrl(ctype, item.id);
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 1500); toast.success("Share link copied"); }
    catch { toast.error("Couldn't copy"); }
  };
  return (
    <div className="fixed inset-0 z-[75] bg-black/85 flex items-start justify-center p-4 overflow-y-auto" onClick={onClose} data-testid="promo-kit-modal">
      <div onClick={(e) => e.stopPropagation()} className="bg-[var(--surface)] border border-neutral-800 p-6 max-w-4xl w-full my-8">
        <div className="flex justify-between items-start mb-6 gap-4">
          <div className="min-w-0">
            <div className="font-mono-label text-[10px] text-[var(--accent)] mb-1">PROMO KIT</div>
            <h3 className="font-headline text-2xl uppercase truncate">{item.title}</h3>
            <div className="font-mono-label text-[10px] text-neutral-400">{item.artist}</div>
          </div>
          <button onClick={onClose} data-testid="promo-kit-close" aria-label="Close"><X size={18} /></button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_1.3fr_1.6fr] gap-5 items-start mb-6">
          {PROMO_FORMATS.map((p) => <PromoTile key={p.fmt} ctype={ctype} id={item.id} {...p} />)}
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <button onClick={copy} className="flex-1 flex items-center justify-between gap-3 px-4 py-3 border border-neutral-800 hover:border-[var(--accent)] min-w-0" data-testid="promo-kit-copy-link">
            <span className="font-mono-label text-[11px] text-neutral-300 truncate">{link}</span>
            <span className="font-mono-label text-[10px] text-[var(--accent)] flex items-center gap-1 shrink-0">{copied ? <><Check size={12} /> COPIED</> : <><Copy size={12} /> COPY</>}</span>
          </button>
          <button onClick={() => setShareOpen(true)} className="btn-primary justify-center" data-testid="promo-kit-share"><Share2 size={14} /> Share</button>
        </div>
      </div>
      {shareOpen && (
        <div onClick={(e) => e.stopPropagation()}>
          <ShareSheet open onClose={() => setShareOpen(false)} title={item.title} artist={item.artist} ctype={ctype} id={item.id} />
        </div>
      )}
    </div>
  );
};
